import Modal from "../../../components/portal/Modal";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";

function UpdateBulkUserSheetErrors({ errorList, closeAction }) {
  return (
    <Modal onClose={closeAction} modalWidth="flex-center-align sheet-container">
      <div className="w-full px-8 m-auto">
        <h1 className="sheetHeading">There are some errors in your sheet</h1>
        <div className="overflow-y-auto max-h-[500px]">
          {errorList && errorList.length > 0 && (
            <table className="sheet-table">
              <tr className="sheetTableHeadRow">
                <th className="sheetTableTh">Row No.</th>
                <th className="sheetTableTh">User Id</th>
                <th className="sheetTableTh">User Name</th>
                <th className="sheetTableTh">Error Description</th>
              </tr>
              {errorList.map((error, index) => {
                return (
                  <tr
                    key={index}
                    className="sheetTableBodyTr [&_td]:p-1.5 [&_td]:border [&_td]:border-lg6"
                  >
                    <td>{error.row ? error.row : "-"}</td>
                    <td>{error.user_id}</td>
                    <td>{error.name}</td>
                    <td className="text-left">
                      {error.description.map((desc, ind) => {
                        return (
                          <div className="px-2" key={ind}>
                            {desc}
                          </div>
                        );
                      })}
                    </td>
                  </tr>
                );
              })}
            </table>
          )}
        </div>
        <div className="mt-8 flex justify-center ">
          <GrayButton btnText="Close" onClick={closeAction} />
        </div>
      </div>
    </Modal>
  );
}
export default UpdateBulkUserSheetErrors;
